import React from 'react';
import { Mail, Phone, MapPin, Shield, Globe, Linkedin } from 'lucide-react';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <Logo variant="light" className="mb-6" />
            <p className="text-gray-400">
              Leading the future of rail logistics with innovative solutions and unmatched expertise.
            </p>
            <div className="mt-4">
              <a
                href="https://www.linkedin.com/company/geometrix-rail-logistics"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center text-gray-400 hover:text-white transition-colors"
              >
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="/" className="text-gray-400 hover:text-white transition-colors">Home</a></li>
              <li><a href="/about" className="text-gray-400 hover:text-white transition-colors">About</a></li>
              <li><a href="/services" className="text-gray-400 hover:text-white transition-colors">Solutions</a></li>
              <li><a href="/contact" className="text-gray-400 hover:text-white transition-colors">Contact</a></li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-bold mb-4">Our Solutions</h3>
            <ul className="space-y-2">
              <li className="text-gray-400">Managed Services</li>
              <li className="text-gray-400">Yard Management System</li>
              <li className="text-gray-400">Fleet Management</li>
              <li className="text-gray-400">Car Hire Management</li>
              <li className="text-gray-400">Railinc Integration Services</li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Info</h3>
            <div className="space-y-3">
              <p className="flex items-center text-gray-400">
                <MapPin className="h-5 w-5 mr-2 text-blue-400" />
                Calgary, AB (Canada)
              </p>
              <p className="flex items-center text-gray-400">
                <Phone className="h-5 w-5 mr-2 text-blue-400" />
                (888) 275-2775
              </p>
              <p className="flex items-center text-gray-400">
                <Mail className="h-5 w-5 mr-2 text-blue-400" />
                sales@geometrix.com
              </p>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} GeoMetrix. All rights reserved.
            </p>
            <div className="flex items-center space-x-4 mt-4 md:mt-0">
              <Shield className="h-5 w-5 text-blue-400" />
              <span className="text-sm text-gray-400">ISO 9001:2015 Certified</span>
              <Globe className="h-5 w-5 text-blue-400" />
              <span className="text-sm text-gray-400">Global Coverage</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;